import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { CompactMenu } from 'components/atoms/menu/compact-menu';
import { IntegrationStatusTypes } from 'components/organisms/module-settings/integrations/integrations-list/authentication-types';
import { RoutePaths } from 'constant';
import { getHubspotMappingsUrl, getHubspotSettingsUrl } from 'utils/urls';

const protectedTabs = [RoutePaths.hubspotResourceMappings];

const validateDisabledStatus = (isAuthenticated: boolean) => (key: string) =>
  !isAuthenticated ? protectedTabs.includes(key) : false;

export const HuspotNavigationTab = ({ integrationId, integrationStatus }) => {
  const location = useLocation();

  const isAuthenticated =
    integrationId !== 'new' &&
    integrationStatus !== IntegrationStatusTypes.Expired;
  const getDisabledStatus = validateDisabledStatus(isAuthenticated);

  return (
    <CompactMenu selectedKeys={[location.pathname]} mode="horizontal">
      <CompactMenu.Item
        key={getHubspotSettingsUrl(integrationId)}
        disabled={getDisabledStatus(RoutePaths.hubspotSettings)}
      >
        <Link to={getHubspotSettingsUrl(integrationId)}>
          <FormattedMessage id="connection" />
        </Link>
      </CompactMenu.Item>
      <CompactMenu.Item
        key={getHubspotMappingsUrl(integrationId)}
        disabled={getDisabledStatus(RoutePaths.hubspotResourceMappings)}
      >
        <Link to={getHubspotMappingsUrl(integrationId)}>
          <FormattedMessage id="fields_sync" />
        </Link>
      </CompactMenu.Item>
    </CompactMenu>
  );
};
